<template>
	<div
		v-if="visible"
		class="general-message"
		:class="[
			type && `general-message--type-${type}`,
			{
				'general-message--auto': !!delay,
			},
		]"
		@click="$emit('click')"
	>
		<div
			class="general-message__text"
			v-html="message"
		/>
		<button
			class="general-message__close"
			v-if="!stick"
			@click.prevent.stop="close"
		>
			<SVGClose/>
		</button>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: '', // can be 'info', 'warning', 'error' or 'promo'
		},
		message: String,
		delay: {
			type: Number,
			default: 0, // number of seconds for auto-closing
		},
		stick: Boolean,
	},
	data() {
		return {
			visible: true,
			timeout: null
		};
	},
	mounted() {
		clearTimeout(this.timeout);
		if (this.delay) {
			this.timeout = setTimeout(this.close.bind(this), this.delay * 1000);
		}
	},
	methods: {
		open() {
			clearTimeout(this.timeout);
			this.visible = true;
			this.$emit('open');
		},
		close() {
			clearTimeout(this.timeout);
			this.visible = false;
			this.$emit('close');
		}
	}
}
</script>

<style>

</style>